// @mui
import { GlobalStyles as MUIGlobalStyles } from '@mui/material';

// ----------------------------------------------------------------------

export default function GlobalStyles() {
  const inputGlobalStyles = (
    <MUIGlobalStyles
      styles={{
        '*': {
          boxSizing: 'border-box',
        },
        html: {
          margin: 0,
          padding: 0,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
        },
        body: {
          margin: 0,
          padding: 0,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: '100%',
        },
        '#root': {
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: '100%',
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        img: {
          display: 'block',
          maxWidth: '100%',
        },
        ul: {
          margin: 0,
        },
        '*::-webkit-scrollbar': {
          width: '0.6em',
          height: '0.6em',
        },
        '*::-webkit-scrollbar-track': {
          WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(0,0,0,.2)',
          outline: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
        },
        '.lightMode': {
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        },
        '.lightMode > *': {
          flexGrow: 1,
          flex: 'auto',
        },
        '.darkMode': {
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        },
        '.darkMode > *': {
          flexGrow: 1,
          flex: 'auto',
        },
      }}
    />
  );

  return inputGlobalStyles;
}
